require('./insuranceRequestPlans.scss');
require('./insuranceRequestPlans.override.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const className = require('classnames');

// @ utils
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const OKCarousel = require('components/commons/OKCarousel/OKCarousel');

// @ constants
const { COVERAGES, PLANS, PAYMENT_TYPE } = require('../../insuranceConstants/insuranceRequestHome');
const { FOURTH_STEP } = require('constants/index');
const PLANS_ORDERED = [PLANS.BASIC, PLANS.MEDIUM, PLANS.HIGH];

// @ components
const InsuranceRequestPlansApplyButton = require('./insuranceRequestPlansComponents/insuranceRequestPlansApplyButton')
const InsuranceRequestPlansHeader = require('./insuranceRequestPlansComponents/insuranceRequestPlansHeader')
const InsuranceRequestPlansHeaderCell = require('./insuranceRequestPlansComponents/insuranceRequestPlansHeaderCell')
const InsuranceRequestPlansRowValue = require('./insuranceRequestPlansComponents/insuranceRequestPlansRowValue')

class InsuranceRequestPlans extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeColumn: 0,
            allColumnsDisabled: true,
            showDetailsModal: false,
        };

        this.handleActivePlanOnTable = this.handleActivePlanOnTable.bind(this);
        this.handleHoverColumn = this.handleHoverColumn.bind(this);
        this.handleClickSelectPlan = this.handleClickSelectPlan.bind(this);
        this.handleClickSelectPlanRelated = this.handleClickSelectPlanRelated.bind(this);
        this.handleToggleDetailsModal = this.handleToggleDetailsModal.bind(this);
        this.isColumnDisabled = this.isColumnDisabled.bind(this);
    }

    componentDidMount() {
        const { immInsuranceWizardStep, isRnc, isPostAppraisal } = this.props
        this.handleActivePlanOnTable();
        if (isRnc) {
            const { requestInsuranceRelatedRNCCurrentPricing } = this.props
            const idInsurance = immInsuranceWizardStep.getIn(['quotationData', 'idInsurance'])
            if (isPostAppraisal) {
                requestInsuranceRelatedRNCCurrentPricing(idInsurance)
            }
        }
    }

    handleHoverColumn(evt) {
        const cell = evt.currentTarget;
        const columnIdx = cell && cell.cellIndex ? cell.cellIndex - 1 : 0;

        this.setState({
            activeColumn: columnIdx,
            allColumnsDisabled: false,
            selected: false
        });
    }

    handleActivePlanOnTable() {
        const { immInsuranceWizardStep } = this.props;
        const selectedPlan = immInsuranceWizardStep.get('insurancePlan');

        if (selectedPlan) {
            this.setState({
                activeColumn: PLANS_ORDERED.indexOf(selectedPlan)
            });
        }
    }

    handleToggleDetailsModal(evt) {
        const { onChangeShowCoverageDetailTable } = this.props;
        evt && evt.preventDefault();
        onChangeShowCoverageDetailTable()
    }

    handleClickSelectPlan(evt, plan) {
        evt.preventDefault();
        const { insuranceSelectPlan, recordEventSelectPlan } = this.props;

        recordEventSelectPlan(plan);
        insuranceSelectPlan(plan, false);
    }

    handleClickSelectPlanRelated(plan) {
        const { selectPlanInRelatedWizardStep3, setData, recordEventSelectPlan } = this.props;

        recordEventSelectPlan(plan);

        selectPlanInRelatedWizardStep3(plan);
        setData(FOURTH_STEP, {
            paymentType: PAYMENT_TYPE.ANNUAL
        });
    }

    buildShowRowTooltip(label) {
        return (
            <OKTooltip
                content={label}
                offset={[0, -15]}
            />
        );
    }

    buildCarouselCoverageRow(coveragePlan, key) {
        const {
            immInsuranceWizardStep,
            insuranceUsabilityImprovementsFlag,
            isRelated,
            isRnc,
            onhandleChangeSelectedPlanInStateComponent,
            requestInsuranceRelatedRNCCurrentPricing,
        } = this.props;

        const coverageGetPlanData = immInsuranceWizardStep.getIn(['coveragesAndPlansData', coveragePlan]).toJS();
        const coverageDataRow = coverageGetPlanData.map((item, idx) => {
            const camelCaseItemName = item.name.toLowerCase();
            const categoryName = formatText(`insuranceRequestHome-step3${camelCaseItemName}`);
            const fireStoleValidation = camelCaseItemName === 'fires' || camelCaseItemName === 'stole';
            const brokenGlassWaterDamageValidation = camelCaseItemName === 'broken_glass' || camelCaseItemName === 'water_damage';

            let rowTooltip = null;

            if (fireStoleValidation || brokenGlassWaterDamageValidation) {
                rowTooltip = this.buildShowRowTooltip(`insuranceRequestHome-step3${camelCaseItemName}Tooltip`);
            }

            return (
                <tbody key={idx} className="coverage-and-plans__main-row">
                    <OKTableRow className="coverage-and-plans__table-row-carousel">
                        <OKTableCell className="coverage-and-plans__table-category">
                            {categoryName}
                            {rowTooltip}
                        </OKTableCell>
                    </OKTableRow>
                    <OKTableRow className="coverage-and-plans__table-row-carousel">
                        <OKTableCell className="coverage-and-plans__table-category">
                            <InsuranceRequestPlansRowValue
                                insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
                                type={item.type}
                                value={item.value}
                            />
                        </OKTableCell>
                    </OKTableRow>
                </tbody>
            );
        });
        const selectingAPlan = isRelated ? this.handleClickSelectPlanRelated : this.handleClickSelectPlan;
        const coveragesTable = (
            <div key={key}>
                <table>
                    <thead>
                        <tr>
                            <OKTableCell
                                className="coverage-and-plans__table-cell-header coverage-and-plans__table-cell-header--title"
                                asHeader={true}
                            >
                                <div className="coverage-and-plans__table-cell-title">
                                    {formatText('insuranceRequestHome-step3CoveragesAndGuaranteesTableTitle')}
                                    <a className="buttons-base buttons-base--additional-action-primary coverage-and-plans__link" onClick={this.handleToggleDetailsModal}>
                                        {formatText('insuranceRequestHome-step3ViewDetailLink')}
                                    </a>
                                </div>
                            </OKTableCell>
                        </tr>
                        <tr className="coverage-and-plans__table-row-carousel">
                            <InsuranceRequestPlansHeaderCell
                                column={0}
                                immInsuranceWizardStep={immInsuranceWizardStep}
                                insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
                                isColumnDisabled={this.isColumnDisabled}
                                onHandleHoverColumn={this.handleHoverColumn}
                                plan={coveragePlan}
                            />
                        </tr>
                    </thead>
                    {coverageDataRow}
                    <tbody>
                        <OKTableRow className="coverage-and-plans__table-row">
                            {
                                InsuranceRequestPlansApplyButton(
                                    coveragePlan,
                                    key,
                                    immInsuranceWizardStep,
                                    this.isColumnDisabled,
                                    this.handleHoverColumn,
                                    selectingAPlan,
                                    isRelated,
                                    onhandleChangeSelectedPlanInStateComponent,
                                    requestInsuranceRelatedRNCCurrentPricing,
                                    isRnc
                                )
                            }
                        </OKTableRow>
                    </tbody>
                </table>
            </div>
        );

        return coveragesTable;
    }

    buildCarouselTableBlocks() {
        return PLANS_ORDERED.map((planKey, idx) => this.buildCarouselCoverageRow(planKey, idx));
    }

    buildCoverageRow(coverageItemName, coverageLabel, showTooltip) {
        const {
            immInsuranceWizardStep,
            insuranceUsabilityImprovementsFlag,
        } = this.props;

        const coveragePlanCells = PLANS_ORDERED.map((planKey, idx) => {
            const coveragePlan = immInsuranceWizardStep.getIn(['coveragesAndPlansData', planKey]);
            const coverageItem = coveragePlan.find(item => item.get('name') === coverageItemName);
            const coverageRowValue = (
                <InsuranceRequestPlansRowValue
                    insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
                    type={coverageItem.get('type')}
                    value={coverageItem.get('value')}
                />
            )

            const coverageRowClass = className('coverage-and-plans__table-cell', {
                'coverage-and-plans__table-cell--disabled': this.isColumnDisabled(idx)
            });

            return (
                <td
                    key={idx}
                    className={coverageRowClass}
                    onMouseEnter={this.handleHoverColumn}
                >
                    {coverageRowValue}
                </td>
            );
        });

        const tooltip = showTooltip ? this.buildShowRowTooltip(showTooltip) : null;

        return (
            <OKTableRow className="coverage-and-plans__table-row">
                <td className="coverage-and-plans__table-category">
                    <span className="coverage-and-plans__table-category-value">{coverageLabel}</span>
                    {tooltip}
                </td>
                {coveragePlanCells}
            </OKTableRow>
        )
    }

    getTitlePlansByStoleCoverage(coverageItemName) {
        const {
            immInsuranceWizardStep,
        } = this.props;

        const coveragePlanCells = PLANS_ORDERED.map((planKey) => {
            const coveragePlan = immInsuranceWizardStep.getIn(['coveragesAndPlansData', planKey]);
            const coverageItem = coveragePlan.find(item => item.get('name') === coverageItemName);
            let id = Number(coverageItem.get('value'));
            return PLANS_ORDERED[id];
        });

        return coveragePlanCells;
    }

    isColumnDisabled(column) {
        const {
            immInsuranceWizardStep,
            insuranceUsabilityImprovementsFlag,
        } = this.props;

        const selectedPlan = immInsuranceWizardStep.get('insurancePlan');

        return !insuranceUsabilityImprovementsFlag || !this.state.allColumnsDisabled || !!selectedPlan ?
            this.state.activeColumn !== column :
            false;
    }

    render() {
        const {
            immInsuranceWizardStep,
            insuranceUsabilityImprovementsFlag,
            isRelated,
            onhandleChangeSelectedPlanInStateComponent,
            requestInsuranceRelatedRNCCurrentPricing,
            isRnc
        } = this.props;
        const context = isRelated ? 'insuranceRelatedRequest' : 'insuranceRequestHome';
        const stoleLabel = formatText('insuranceRequestHome-step3stole');
        const firesLabel = formatText('insuranceRequestHome-step3fires');
        const waterDamageLabel = formatText('insuranceRequestHome-step3water_damage');
        const brokenGlassLabel = formatText('insuranceRequestHome-step3broken_glass');
        const legalDefenseLabel = formatText('insuranceRequestHome-step3legal_defense');
        const civilLiabilityLabel = formatText('insuranceRequestHome-step3civil_liability');
        const dangerousDogsLabel = formatText('insuranceRequestHome-step3dangerous_dogs');
        const aestheticDamageLabel = formatText('insuranceRequestHome-step3aesthetic_damage');
        const electricalDamageLabel = formatText('insuranceRequestHome-step3electrical_damage');

        const stoleTooltip = <FormattedText value={`${context}-step3stoleTooltip`} />;
        const firesTooltip = <FormattedText value="insuranceRequestHome-step3basicTooltip" />;
        const brokenGlassTooltip = <FormattedText value={"insuranceRelatedRequest-step3broken_glassTooltip"} />;
        const civilLiabilityTooltip = <FormattedText value={"insuranceRequestHome-step3civil_liabilityTooltip"} />;

        const titlePlansByStoleCoverage = this.getTitlePlansByStoleCoverage(COVERAGES.STOLE);
        const buildStoleRow = this.buildCoverageRow(COVERAGES.STOLE, stoleLabel, stoleTooltip);
        const buildFiresRow = this.buildCoverageRow(COVERAGES.FIRES, firesLabel, firesTooltip);
        const buildWaterDamageRow = this.buildCoverageRow(COVERAGES.WATER_DAMAGE, waterDamageLabel);
        const buildBrokenGlassRow = this.buildCoverageRow(COVERAGES.BROKEN_GLASS, brokenGlassLabel, brokenGlassTooltip);
        const buildLegalDefenseRow = this.buildCoverageRow(COVERAGES.LEGAL_DEFENSE, legalDefenseLabel);
        const buildCivilLiabilityRow = this.buildCoverageRow(COVERAGES.CIVIL_LIABILITY, civilLiabilityLabel, civilLiabilityTooltip);
        const buildDangerousDogsRow = this.buildCoverageRow(COVERAGES.DANGEROUS_DOGS_NUMBER, dangerousDogsLabel);
        const buildAestheticDamageRow = this.buildCoverageRow(COVERAGES.AESTHETIC_DAMAGE, aestheticDamageLabel);
        const buildElectricalDamageRow = this.buildCoverageRow(COVERAGES.ELECTRICAL_DAMAGE, electricalDamageLabel);
        const selectingAPlan = isRelated ? this.handleClickSelectPlanRelated : this.handleClickSelectPlan;
        const buildApplyButtons = PLANS_ORDERED.map((plan, idx) => InsuranceRequestPlansApplyButton(
            plan,
            idx,
            immInsuranceWizardStep,
            this.isColumnDisabled,
            this.handleHoverColumn,
            selectingAPlan,
            isRelated,
            onhandleChangeSelectedPlanInStateComponent,
            requestInsuranceRelatedRNCCurrentPricing,
            isRnc
        ));
        const settings = {
            className: 'coverage-and-plans__carousel',
            dots: true,
            speed: 500,
            infinite: false,
            slidesToShow: 1,
            draggable: false,
            arrows: false,
            initialSlide: 0
        };
        const coveragesAndPlansBlock = this.buildCarouselTableBlocks();

        return (
            <div className="coverage-and-plans">
                <div className="row">
                    <div className="col-sm-12 visible-md visible-lg">
                        <table
                            className="coverage-and-plans__table"
                            onMouseLeave={this.handleActivePlanOnTable}
                        >
                            <thead>
                                <InsuranceRequestPlansHeader
                                    immInsuranceWizardStep={immInsuranceWizardStep}
                                    insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
                                    isColumnDisabled={this.isColumnDisabled}
                                    onHandleHoverColumn={this.handleHoverColumn}
                                    plansOrdered={PLANS_ORDERED}
                                    titlePlans={titlePlansByStoleCoverage}
                                />
                            </thead>
                            <tbody>
                                {insuranceUsabilityImprovementsFlag && buildStoleRow}
                                {buildFiresRow}
                                {buildBrokenGlassRow}
                                {buildWaterDamageRow}
                                {buildLegalDefenseRow}
                                {buildElectricalDamageRow}
                                {buildCivilLiabilityRow}
                                {buildDangerousDogsRow}
                                {buildAestheticDamageRow}
                                {!insuranceUsabilityImprovementsFlag && buildStoleRow}
                                <OKTableRow className="coverage-and-plans__table-row">
                                    <OKTableCell className="coverage-and-plans__table-category">
                                        <OKButton
                                            modifier="link-emphasize"
                                            onClick={this.handleToggleDetailsModal}
                                        >
                                            {formatText('insuranceRequestHome-step3ViewDetailLink')}
                                        </OKButton>
                                    </OKTableCell>
                                    {buildApplyButtons}
                                </OKTableRow>
                            </tbody>
                        </table>
                    </div>
                    <div className="visible-xs visible-sm">
                        <OKCarousel
                            settings={settings}
                            blocks={coveragesAndPlansBlock}
                            leftButtonClass="ok-carousel__left-button"
                            rightButtonClass="ok-carousel__right-button"
                            leftIcon="icon-anterior"
                            rightIcon="icon-siguiente"
                            customClass="coverage-and-plans-ok-carousel"
                        />
                    </div>
                </div>
            </div>
        )
    }
}

InsuranceRequestPlans.propTypes = {
    immInsuranceWizardStep: PropTypes.object.isRequired,
    insuranceSelectPlan: PropTypes.func.isRequired,
    insuranceUsabilityImprovementsFlag: PropTypes.bool,
    isPostAppraisal: PropTypes.bool,
    isRelated: PropTypes.bool,
    isRnc: PropTypes.bool,
    onChangeShowCoverageDetailTable: PropTypes.func.isRequired,
    onhandleChangeSelectedPlanInStateComponent: PropTypes.func,
    recordEventSelectPlan: PropTypes.func,
    requestInsuranceRelatedRNCCurrentPricing: PropTypes.func,
    selectPlanInRelatedWizardStep3: PropTypes.func,
    setData: PropTypes.func.isRequired,
};

InsuranceRequestPlans.defaultProps = {
    selectPlanInRelatedWizardStep3: () => { },
    onhandleChangeSelectedPlanInStateComponent: () => { },
    requestInsuranceRelatedRNCCurrentPricing: () => { },
    recordEventSelectPlan: () => { }
};

module.exports = InsuranceRequestPlans;

